import React from 'react';
import { throttle } from 'lodash';

import Intro from './Intro';
import Grafica from './Grafica';
import Grafica2 from './Grafica2';
import Copy from './Copy';
import Publicado from './Publicado';
import ImagenMax from './ImagenMax';
import Gif from './Gif';
import Footer from './Footer';
import Pie from './Pie';
import FirmaFinal from './FirmaFinal';
import SubtituloNegro from './SubtituloNegro';

const delay = 200;

class Logistica extends React.Component {
	state = {
		windowWidth: window.clientWidth,
		windowHeight: window.innerHeight
	};

	componentDidMount() {
		window.addEventListener('resize', throttle(this.handleResize, delay));
	}

	handleResize = event => {
		this.setState({
			windowWidth: window.clientWidth,
			windowHeight: window.innerHeight
		});
	};

	render() {
		return (
			<div>
				<div>
					<Intro
						windowWidth={this.state.windowWidth}
						windowHeight={this.state.windowHeight}
						pilotos={this.state.pilotos}
						joly={
						typeof this.props.match.params.joly === "undefined"
							? "dj"
							: this.props.match.params.joly
					}
					/>
					<Pie contenido={'Fotos: Dorna'} />
					<Publicado contenido={'domingo 22 de abril'} />

					<Copy
						contenido={
							'Volando va, volando viene el Mundial de Motociclismo. Desde Estados Unidos con rumbo a España viaja ya caminito de Jerez el apasionante MotoGP. Tras las tres primeras pruebas de la temporada, disputadas en Qatar, Argentina y USA, le toca ahora el turno a Andalucía como puerta de Europa en su trazado jerezano que, por trigésimo segunda vez en la historia, está a punto de recibir la espectacular caravana del Continental Circus de las dos ruedas. '
						}
					/>
					<SubtituloNegro
						contenido={
							'Más de 360 toneladas se trasladan de un continente a otro'
						}
					/>

					<Grafica />
					<Grafica2 />
					<Copy
						contenido={
							'La expectación que genera este Gran Premio de España 2018 es enorme, tanto por razones deportivas, como económicas y emocionales, pues servirá también para rendir merecido homenaje a la figura del tristemente fallecido campeón Ángel Nieto que, en la primera semana de mayo, unirá su nombre con el del Circuito de Jerez. Se trata pues de un acontecimiento que va más allá de las batallas que las estrellas de MotoGP han protagonizado en las anteriores pruebas de Losail, Termas y Austin. De lo que acontece con Márquez, Rossi (o viceversa), Dovizioso, Pedrosa y un larguísimo etcétera, va a hablarse hasta la extenuación en los próximos días. De ahí que no estaría mal poner la vista previamente en otros detalles dignos de mención, como son la logística que hace posible llegar desde América hasta Jerez este espectáculo multitudinario.'
						}
					/>
					<ImagenMax contenido={'1'} />
					<Copy
						contenido={
							'Siempre ponemos toda la atención en las apasionantes luchas entre los mejores pilotos del mundo y, en muchos casos, hay otros puntos de gran interés en MotoGP que a veces pasan desapercibidos. Este es el caso del laborioso traslado de motos y material desde un continente a otro, una labor exigente, complicada y a la vez fascinante. Justo al acabar el Gran Premio de Estados Unidos se puso en marcha el dispositivo encargado de transportar hasta Jerez 367.000 kilos de material, distribuidos en 920 contenedores, que entre 45 y 55 camiones se encargan de movilizar desde el circuito de Texas hasta el aeropuerto de Austin, para ser embarcados en 4 aviones Boeing 747 con destino a Sevilla.'
						}
					/>
					<ImagenMax contenido={'2'} />
					<Gif contenido={'1'} />
					<Copy
						contenido={
							'Cada equipo del Mundial hace sus cajas con motos (más del centenar) y diverso material, al igual que el resto de logística del Campeonato, tanto de televisión, cronometraje, publicidad, administración, etc. Son 24 horas de intenso trabajo para el equipo que dirige Carles Jorba, director de operaciones de Dorna (empresa que gestiona el Mundial de MotoGP) y la multinacional DHL que les da soporte en esta dura tarea: “Cuando los domingos acaba un Gran Premio, nosotros comenzamos otro contra el reloj para llegar a tiempo a la siguiente carrera, desplazando toda la logística desde un país o un continente a otro”, señala Jorba.'
						}
					/>
					<ImagenMax contenido={'3'} />
					<Gif contenido={'2'} />
					<Copy
						contenido={
							'En paralelo a ese traslado de material, la gran familia del Mundial moviliza también en torno a las 3.000 personas (pilotos, integrantes de equipos, organización, periodistas, etcétera), por lo que puede imaginarse el volumen real de esta “comitiva nómada”. De los diecinueve grandes premios que se realizarán este año, en ocho de ellos se utilizarán estos complejos desplazamientos por avión, mientras que en los once que transcurrirán en suelo europeo, la caravana del Mundial de MotoGP, que abarca 15 países de cuatro continentes, se trasladará de un país a otro por carretera mediante camiones. En cada temporada del Campeonato del Mundo se transportan por tierra, mar y aire más de 360 toneladas del material utilizado por 46 equipos, en los que militan 84 pilotos de las tres categorías, además de la logística del propio organizador del Mundial, cubriendo una distancia aproximada de 90.000 km. en el transcurso de nueve meses. Es un trabajo frenético y digno de elogios.'
						}
					/>
					<ImagenMax contenido={'4'} />
					<Gif contenido={'3'} />
					<Copy
						contenido={
							'También es justo reconocer la ingente labor que desde hace ya meses se lleva a cabo en el propio Circuito de Jerez, para ofrecer su mejor imagen, sin olvidar el soporte que prestarán los 2.700 efectivos de los cuerpos y fuerzas de seguridad del Estado, junto a los 580 efectivos de seguridad privada. La organización está compuesta por 441 miembros, entre comisarios de pista y boxes, personal contra incendios y de rescate, mantenimiento, comisarios técnicos, personal dirección de carrera y equipo de prensa, con una previsión de público por encima de los 100.000 espectadores. En todos los sentidos, son cifras de récord.'
						}
					/>
					<ImagenMax contenido={'5'} />
					<Copy
						contenido={
							'Siempre que se acerca el Gran Premio de España de MotoGP, pienso indefectiblemente en la frenética actividad que estará llevando Pablo Fernández, jefe de mantenimiento de las instalaciones, que trabaja casi de sol a sol desde que se puso la primera piedra en el trazado andaluz. Y junto con él, toda la abnegada plantilla del Circuito, a la que se unen muchos otros efectivos bajo la supervisión general del Ayuntamiento de Jerez, con la especial dedicación de Santiago Galván, vicepresidente de Cirjesa (empresa pública que gestiona el Circuito de Jerez). Ellos son también los impulsores de los primeros “Premios del Motor Ciudad de Jerez”, que serán entregados el día 4 de mayo a Valentino Rossi, Carmelo Ezpeleta y Paco Pacheco, además de los accésit a la familia Nieto y Renault, premiados todos ellos por su trayectoria y vinculación con este trazado en los 32 años de historia que ya le contemplan.'
						}
					/>
					<ImagenMax contenido={'6'} />
					<Copy
						contenido={
							'Las estrellas de MotoGP disfrutarán este año de un nuevo asfalto en el Circuito de Jerez, con la consiguiente expectación que genera comprobar cómo se pulverizan los récords de la pista. Seguro que desde el cielo, Ángel Nieto está ya a la espera de ver cómo transcurre el Gran Premio de España en su Circuito y con la mejor afición del mundo caminito de Jerez…'
						}
					/>
					<FirmaFinal />

					<Footer joly={
						typeof this.props.match.params.joly === "undefined"
							? "dj"
							: this.props.match.params.joly
					}
				/>
				</div>
			</div>
		);
	}
}

export default Logistica;



// WEBPACK FOOTER //
// ./src/components/Logistica.js